<script>
import resources from './resources'

export default {
  name: 'menu-config',

  mixins: [resources]
}
</script>

<template lang="pug">
  li.config(v-if="!(!user.id)")
    | 
    .config-drop
      .title
        span.icon 
        h4 Configurações
      .subtitle Notificações
      .line
        .text Agenda Diária
        .switch(
          @click.prevent="doToogleNotifySettings('weeklySchedule')",
          :class="{true: settings.notify.weeklySchedule, false: !settings.notify.weeklySchedule}"
          )
          .dot
      .line
        .text Resumo Semanal
        .switch(
          @click.prevent="doToogleNotifySettings('weeklySummary')",
          :class="{true: settings.notify.weeklySummary, false: !settings.notify.weeklySummary}"
          )
          .dot
      .line
        .text Estatísticas de Atendimento
        .switch(
          @click.prevent="doToogleNotifySettings('supportStatistics')",
          :class="{true: settings.notify.supportStatistics, false: !settings.notify.supportStatistics}"
          )
          .dot

      .divider
      .subtitle Modo de integração
      .line
        .text Offline
        .switch(
          @click.prevent="doToogleIntegrationSettings('offline')",
          :class="{true: settings.notify.integration.offline, false: !settings.notify.integration.offline}"
          )
          .dot
      .line
        .text API Própria
        .switch(
          @click.prevent="doToogleIntegrationSettings('ownApi')",
          :class="{true: settings.notify.integration.ownApi, false: !settings.notify.integration.ownApi}"
          )
          .dot
      .line
        .text API Medibook
        .switch(
          @click.prevent="doToogleIntegrationSettings('medibookApi')",
          :class="{true: settings.notify.integration.medibookApi, false: !settings.notify.integration.medibookApi}"
          )
          .dot
      .divider
      .subtitle Tipo de Notificações
      .line
        .text E-mail
        .switch(
          @click.prevent="doToogleNotifySendSettings('email')",
          :class="{true: settings.notify.send.email, false: !settings.notify.send.email}"
          )
          .dot
      //- .line
      //-   .text SMS
      //-   .switch(
      //-     @click.prevent="doToogleNotifySendSettings('sms')",
      //-     :class="{true: settings.notify.send.sms, false: !settings.notify.send.sms}"
      //-     )
      //-     .dot
      //- .line
      //-   .text
      //-     | App Mobile
      //-     small (Smartphones)
      //-   .switch(
      //-     @click.prevent="doToogleNotifyPushAppSettings()",
      //-     :class="{true: settings.notify.send.push.app, false: !settings.notify.send.push.app}"
      //-     )
      //-     .dot
      //- .line
      //-   .text
      //-     | App Web
      //-     small (Push Notifications)
      //-   .switch(
      //-     @click.prevent="doToogleNotifyPushWebSettings()",
      //-     :class="{true: settings.notify.send.push.web, false: !settings.notify.send.push.web}"
      //-     )
      //-     .dot
      .divider
      button
        router-link(:to="{name: 'professional.settings.config.index'}")
          span.icon 
          |  Configurações Avançadas
</template>



// WEBPACK FOOTER //
// src/layout/headers/menu/config/config-professional.vue